<template>
	<div id="topnav">
		<div id="top"></div>
		<div id="nav">
			<div class="container">
				<div id="logo"></div>
				<div id="menu">
					<ul>
						<li v-for="(item,index) in links" :key="index" :class="{active: item.value == current}">
							<router-link :to="{name:item.value}">
								<span>{{item.text}}</span>
								<span>{{item.en}}</span>
							</router-link>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import Vue from "vue";

	export default {
		data: function () {
			return {
				links: [
					{
						"text": "首页",
						"value": "index",
						"en": "Home",
					},
					{
						"text": "关于美信",
						"value": "about",
						"en": "About Us",
					},
					{
						"text": "价值准则",
						"value": "criterion",
						"en": "Criterion",
					},
					{
						"text": "专业服务",
						"value": "special",
						"en": "Professional Service"
					},
					{
						"text": "服务优势",
						"value": "advantage",
						"en": "Service Advantage",
					},
					{
						"text": "合作伙伴",
						"value": "partner",
						"en": "Partner"
					},
					{
						"text": "联系我们",
						"value": "contact",
						"en": "Contact"
					},
					{
						"text": "工作机会",
						"value": "job",
						"en": "Career Opportunities"
					}
				],
			};
		},
		computed: {
			current: function () {
				return this.$route.name;
			}
		},
		mounted() {
			//this.fetchMenus();
			const $this = this;
			setTimeout(function () {
				$this.bus.$emit('animate');
			}, 100);
		},
		methods: {
			fetchMenus() {
				const $this = this;
				this.$util.axios.get(
					this.$util.apiUrl("/menu"),
					null,
					function (data) {
						$this.links = data;
						$this.bus.$emit('animate');
					}
				);
			}
		}
	};
</script>
